import React, {PureComponent} from 'react';
import PropTypes from 'prop-types';

import {fireDurations, fireParams} from '../misc/fire.class';
import loadsTabService from '@services/requests/loads-tab.service';
import Spinner from '@components/LoadingStyles/Spinner';
import './styles.scss';
import { APP_TEXTS } from '../../../../../texts/texts';

export default class FireDuration extends PureComponent {

  static propTypes = {
    combination: PropTypes.object.isRequired
  };

  sides = [];

  constructor(props) {
    super(props);

    this.fetchOptions();

    this.state = { isPending: true };
  }

  fetchOptions() {
    loadsTabService.getFireSides()
      .then(sides => this.sides = sides)
      .then(
        this.unsetPending,
        this.unsetPending
      );
  }

  unsetPending = () => this.setState({ isPending: false });

  render() {
    const { combination: { extraField = {} } } = this.props;

    return (
      <div className="calculation fire-duration">
        { this.state.isPending && <Spinner /> }

        <section className="list-type">
          <span>{APP_TEXTS.METHOD_FIRE_EXPOSURE.Content}</span>
          <div>
            <select className="form-control mt-2 ml-0 duration"
                    value={extraField[fireParams.DURATION]}
                    name={[fireParams.DURATION]}
                    defaultValue={extraField[fireParams.DURATION]}
                    onChange={e => this.updateValue(e.target.value, fireParams.DURATION)}
            >
              <option value={fireDurations.THIRTY}>30</option>
              <option value={fireDurations.SIXTY}>60</option>
              <option value={fireDurations.NINETY}>90</option>
              <option value={fireDurations.HUNDRED_TWENTY}>120</option>
            </select>
            <b>&nbsp;{APP_TEXTS.FIRE_DURATION_MINUTES.Content}</b>
          </div>

          <div>
            <select className="form-control w-50 mt-2 ml-0 attack"
                    defaultValue={extraField[fireParams.SIDE]}
                    name={[fireParams.SIDE]}
                    onChange={e => this.updateValue(e.target.value, fireParams.SIDE)}
            >
              {this.sides && this.sides.length && this.sides.map(n => (
                <option value={n['InternalName']} key={n['InternalName']}>{n['RunName']}</option>
              ))}
            </select>
            <b>&nbsp;{APP_TEXTS.SAFETY_BARRIER_FIRE_ATTACK.Content}</b>
          </div>
        </section>
      </div>
    );
  }

  updateValue = (value, key) => {
    this.props.onUpdate({
      [key]: value
    });
  }

}



// WEBPACK FOOTER //
// ./src/views/Loads/GeneralLoading/DesignLoading/FireDuration/FireDuration.js